import { a11yProps } from "../../Utils/TabsAllyProps";

export const CompanyFinepTabs = [
    {
        label: "Cartão CNPJ",
        props: a11yProps(0)
    },
    {
        label: "Endereço",
        props: a11yProps(1),
    },
    {
        label: "Contato",
        props: a11yProps(2)
    },
    {
        label: "Grupo Econômico",
        props: a11yProps(3)
    },
    {
        label: "Composição do Capital Social",
        props: a11yProps(4)
    },
    {
        label: "Outras Informações",
        props: a11yProps(5)
    }
]